var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section" }, [
      _c("span", { staticClass: "tag is-light is-rounded is-medium is-mono" }, [
        _c("i", { staticClass: "fas fa-sync fa-spin fa-fw" }),
        _vm._v(" Cargando"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }